import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";
import { CornerMarkDetailsPageTab } from "./components/CornermarkPage";

export const cornermarkSection = "/cornermark/";
export const cornermarkRefresh = "/cornermark/#";

export const cornermarkListPath = cornermarkSection;

export enum CornermarkListUrlSortField {
  name = "name",
  text = "text",
  created = "created"
}

export enum CornermarkListUrlFiltersEnum {
  createdFrom = "createdFrom",
  createdTo = "createdTo",
  query = "query"
}
export type CornermarkListUrlDialog = "remove" | TabActionDialog;
export type CornermarkListUrlFilters = Filters<CornermarkListUrlFiltersEnum>;
export type CornermarkListUrlSort = Sort<CornermarkListUrlSortField>;
export type CornermarkListUrlQueryParams = ActiveTab &
  CornermarkListUrlFilters &
  CornermarkListUrlSort &
  BulkAction &
  Dialog<CornermarkListUrlDialog> &
  Pagination;

export const cornermarkListUrl = (params?: CornermarkListUrlQueryParams) =>
  cornermarkListPath + "?" + stringifyQs(params);
export type CornermarkAddUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove-value"
  | "remove-values";
export type CornermarkUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove"
  | "remove-value"
  | "remove-values"
  | "assign-category"
  | "assign-collection"
  | "assign-product"
  | "assign-variant"
  | "unassign-category"
  | "unassign-collection"
  | "unassign-product"
  | "unassign-variant";

export type CornermarkAddUrlQueryParams = Dialog<CornermarkAddUrlDialog> &
  SingleAction;
export type CornermarkUrlQueryParams = Pagination &
  BulkAction &
  Dialog<CornermarkUrlDialog> &
  ActiveTab<CornerMarkDetailsPageTab> &
  SingleAction;
export const cornermarkAddPath = urlJoin(cornermarkSection, "add");

export const cornermarkAddUrl = (params?: CornermarkAddUrlQueryParams) =>
  cornermarkAddPath + "?" + stringifyQs(params);

export const cornermarkPath = (id: string) => urlJoin(cornermarkSection, id);
export const cornermarkUrl = (id: string, params?: CornermarkUrlQueryParams) =>
  cornermarkPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
